function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

// load polyfills early
import pageInitializer from '../../lib/client/page-initializer';
import { AppContext } from '../common/app-context.js';
import client from '../../lib/shared/client';
import DevopsWorldLevelNav from '../common/devops-world-level-nav.jsx';
import React from 'react';
import WelcomeContent from './welcome-content.jsx';
import { Provider as CpcProvider } from '@console/cloud-pal-community/components/Basic';
import '../../scss/welcome/welcome.scss';
var Welcome = /*#__PURE__*/function (_React$Component) {
  function Welcome(props) {
    var _this;
    _classCallCheck(this, Welcome);
    _this = _callSuper(this, Welcome, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(Welcome, _React$Component);
  return _createClass(Welcome, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState({
        isMounted: true
      });

      // listen for account load/changes
      header.whenAccountReady(function (data) {
        return _this2.setState({
          account: data.account
        });
      });
      document.addEventListener('acctChanged', function (evt) {
        _this2.setState({
          account: evt.detail.accountData.account
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var appContextValue = {
        account: this.state.account,
        cdnDomain: this.props.context.cdnDomain,
        enableFSCloudDialog: false,
        envId: this.props.context.envId,
        locale: this.props.context.locale,
        readOnly: false
      };
      if (this.state.isMounted) {
        return (
          /*#__PURE__*/
          // fixes useLayoutEffect UI mismatch warning
          // only render it once mounted in the browser
          React.createElement(AppContext.Provider, {
            value: appContextValue
          }, /*#__PURE__*/React.createElement(CpcProvider, null, /*#__PURE__*/React.createElement(DevopsWorldLevelNav, {
            activeItem: "welcome-tab"
          }), /*#__PURE__*/React.createElement(WelcomeContent, _extends({}, this.props, {
            className: "ibm-cloud-app"
          }))))
        );
      }
      return /*#__PURE__*/React.createElement(AppContext.Provider, {
        value: appContextValue
      }, /*#__PURE__*/React.createElement(DevopsWorldLevelNav, {
        activeItem: "welcome-tab"
      }), /*#__PURE__*/React.createElement(WelcomeContent, _extends({}, this.props, {
        className: "ibm-cloud-app"
      })));
    }
  }]);
}(React.Component); // hydrate component on client
export { Welcome as default };
client && pageInitializer.init(Welcome);